module.exports = __webpack_public_path__ + "img/compliance.88a8f7ee.png";